import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppConstants} from '../shared/app.constants';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import {AuthService} from '../auth.service';

@Injectable()
export class ShiftService {

  constructor(private http: HttpClient, private appConstants: AppConstants, private auth: AuthService) {
  }

  getPopupShifts(startDate, endDate): Observable<any> {
    const url = environment.apiBase + `popup/shifts?startDate=${startDate}&endDate=${endDate}`;
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(response => response).catch(this.appConstants.errorHandler);
  }

  getShiftDetails(id): Observable<any> {
    const url = environment.apiBase + `popup/shifts/${id}`;
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(response => response).catch(this.appConstants.errorHandler);
  }

  createPopupShift(body): Observable<any> {
    const url = environment.apiBase + `popup/shifts`;
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.post(url, body, {headers: headers}).map(response => response).catch(this.appConstants.errorHandler);
  }

  deletePopupShift(id): Observable<any> {
    const url = environment.apiBase + `popup/shifts/`+id;
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.delete(url, {headers}).map(response => response).catch(this.appConstants.errorHandler);
  }

}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/shifts/shift.service.ts